export const BUSINESS_APPROVAL_STATUS = {
  APPROVED: 'APPROVE',
  PENDING: 'PENDING',
};

const normalizeStatus = (status) =>
  String(status || '')
    .trim()
    .toUpperCase();

export const getBusinessStatus = (business) =>
  normalizeStatus(business?.status ?? business?.raw?.status);

export const isApprovedBusiness = (business) => {
  const status = getBusinessStatus(business);
  return status === BUSINESS_APPROVAL_STATUS.APPROVED || status === 'APPROVED';
};

export const isPendingBusiness = (business) =>
  getBusinessStatus(business) === BUSINESS_APPROVAL_STATUS.PENDING;

/**
 * Picks the active business for the header switcher.
 * Keeps the current selection when approved; otherwise selects the next approved
 * restaurant in list order, falling back to the first approved entry.
 */
export const resolvePreferredActiveBusinessId = (businesses = [], currentId = null) => {
  if (!businesses.length) return null;

  const currentIndex = businesses.findIndex(
    (item) => String(item.id) === String(currentId ?? ''),
  );
  const current = currentIndex >= 0 ? businesses[currentIndex] : null;

  if (current && isApprovedBusiness(current)) {
    return current.id;
  }

  if (currentIndex >= 0) {
    const nextApproved = businesses.slice(currentIndex + 1).find(isApprovedBusiness);
    if (nextApproved) return nextApproved.id;
  }

  const firstApproved = businesses.find(isApprovedBusiness);
  if (firstApproved) return firstApproved.id;

  return businesses[0]?.id || null;
};
